import { z } from "zod";

export const zQueryBoolean = z.preprocess(value => value === "true" ? true : value === "false" ? false : value, z.boolean());

export const zId = z.string().uuid();
export const zIsoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "expected YYYY-MM-DD");
export const zIsoDateTime = z.string().datetime({ offset: true }).or(z.string().datetime());
export const zMoney = z.number().int().min(0).describe("amount in cents");
export const zSignedMoney = z.number().int().describe("amount in cents, may be negative");
export const zEmail = z.string().trim().toLowerCase().email();
export const zSlug = z.string().regex(/^[a-z0-9][a-z0-9-]*$/);

export const zCursorPagination = z.object({
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(200).default(50),
});
export type CursorPagination = z.infer<typeof zCursorPagination>;

export interface Page<T> {
  items: T[];
  nextCursor: string | null;
  total?: number;
}

export const zSortDir = z.enum(["asc", "desc"]);

export const zApiError = z.object({
  statusCode: z.number(),
  error: z.string(),
  message: z.string(),
  details: z.unknown().optional(),
});
export type ApiError = z.infer<typeof zApiError>;
